export const normalizeRole = (role) =>
  String(role ?? "")
    .trim()
    .toUpperCase()
    .replace(/[\s_-]/g, "");

export const hasRole = (user, expected) =>
  normalizeRole(user?.role) === normalizeRole(expected);
